import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { RequisitionStatus } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RequisitionStatusService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/requisitionStatus',
      httpClient,
      httpFactory
    );
  }

  getRequisitionStatuses(): Observable<RequisitionStatus[]> {
    return this.httpClient.get<RequisitionStatus[]>(`${this.route}`);
  }

  addRequisitionStatus(statusName: string): Observable<void> {
    return this.httpClient.post<void>(`${this.route}`, {
      requisitionStatusName: statusName,
    });
  }
}
